import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { buscarPostPublico } from "../services/blog";
import { getImageUrl } from "../utils/media";
import "./Blog.css";

function formatDate(date) {
  if (!date) return "";

  const parsedDate = new Date(date);
  if (Number.isNaN(parsedDate.getTime())) return "";

  return parsedDate.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

const Post = () => {
  const { idOrSlug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const titleRef = useRef(null);

  useEffect(() => {
    let active = true;

    async function loadPost() {
      try {
        setLoading(true);
        setError("");

        const response = await buscarPostPublico(idOrSlug);
        if (active) setPost(response || null);
      } catch (requestError) {
        if (!active) return;
        console.error("Erro ao carregar post:", requestError);
        setPost(null);
        setError("Não foi possível carregar este post.");
      } finally {
        if (active) setLoading(false);
      }
    }

    loadPost();

    return () => {
      active = false;
    };
  }, [idOrSlug]);

  useEffect(() => {
    if (loading || error || !post) return undefined;

    const animationFrame = window.requestAnimationFrame(() => {
      titleRef.current?.scrollIntoView({ block: "center", behavior: "smooth" });
    });

    return () => window.cancelAnimationFrame(animationFrame);
  }, [error, loading, post]);

  const imageUrl = getImageUrl(post?.images?.[0] || post?.image);
  const authorName = post?.author?.name || post?.authorName || "7 Gerações";
  const publicationDate = post?.publishedAt || post?.createdAt;

  return (
    <main>
      <div className="post">
        {loading && <div className="post__message">Carregando...</div>}

        {!loading && error && <div className="post__message">{error}</div>}

        {!loading && !error && !post && (
          <div className="post__message">Post não encontrado.</div>
        )}

        {!loading && !error && post && (
          <article className="post__content">
            <div className="post-top">
              {imageUrl && <img src={imageUrl} alt={"Capa do post " + post.title} />}

              <div className="post__footer">
                <span className="post__author">Por {authorName}</span>
                <time
                  className="post__date"
                  dateTime={publicationDate || ""}
                >
                  {formatDate(publicationDate)}
                </time>
              </div>
            </div>

            <div className="post-bottom">
              <h1 ref={titleRef}>{post.title}</h1>
              <div className="post__body" dangerouslySetInnerHTML={{ __html: post.content }} />
              <Link className="post__back-link" to="/blog">Voltar para o blog</Link>
            </div>
          </article>
        )}
      </div>
    </main>
  );
};

export default Post;
